import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import {store} from "./store";

//Vendor files
import './assets/js/vendor';

//css
import './assets/css/custom.css';

//js
import './assets/js/daterangepicker.js';
import '@fancyapps/fancybox/dist/jquery.fancybox.js';
import '@fancyapps/fancybox/src/js/thumbs.js';

//plugins
import {i18n} from "./i18n/i18n"
import ValidationPlugin from "./plugins/validation.plugin";
import './plugins/table.plugin.ts';
import './plugins/sweetalert.plugin.ts';
import BootstrapVue from 'bootstrap-vue'
import EditorsPlugin from "./editors/index";
import Slider from "./editors/slider.vue";

//filters
import './filters/date.filter'
import './filters/number.filters'

Vue.use(ValidationPlugin);
Vue.use(BootstrapVue);
Vue.use(EditorsPlugin);
Vue.component('Slider', Slider);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    computed: {
        isAuthenticated: function () {
            return this.$store.getters.isAuthenticated()
        }
    },
    i18n,
    render: h => h(App),
}).$mount("#app");
